import { render } from "./SquadVue.vue?vue&type=template&id=170d9c02"
import script from "./SquadVue.vue?vue&type=script&lang=js"
export * from "./SquadVue.vue?vue&type=script&lang=js"

import "./SquadVue.vue?vue&type=style&index=0&id=170d9c02&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__